<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M20.94 6V3.87c0-1-.81-1.81-1.81-1.81h-1.1c-1 0-1.81.81-1.81 1.81V6h-.21c-.5 0-.9.4-.9.9v8.19c0 .5.4.9.9.9h.21v4.13c0 1 .81 1.81 1.81 1.81h1.1c1 0 1.81-.81 1.81-1.81v-4.13h.15c.5 0 .9-.4.9-.9V6h-1.06.01Zm-2.83-2.06h.94V6h-.94V3.94Zm.95 16.12h-.94V16h.94v4.06ZM11 7a1 1 0 0 0-1-1H8V2H6v4H4a1 1 0 0 0-1 1v5H2v9a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9H5V8h4v4H8v9a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9h-1V7Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
